import { createSlice } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    username: null,
    role: null,
    token: sessionStorage.getItem('token') || null,
    errors: null
  },
  reducers: {
    setUserDetails: (state, action) => {
      state.username = action.payload.username;
      state.role = action.payload.role;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.username = null;
      state.role = null;
      state.token = null;
    },
  },

});

export const { setUsername, setRole, setAccessToken, setErrors, setUserDetails, logout } = userSlice.actions;

export default userSlice.reducer;
